// eslint-disable-next-line import/prefer-default-export
export const generateUniqueId = () => `id${Math.random().toString(16).slice(2)}`;
